import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import {
  comboAddPath,
  ComboAddUrlQueryParams,
  comboListPath,
  ComboListUrlQueryParams,
  ComboListUrlSortField,
  comboPath,
  ComboUrlQueryParams
} from "./urls";
import ComboCreateComponent from "./views/ComboCreate";
import ComboDetailsComponent from "./views/ComboDetails";
import ComboListComponent from "./views/ComboList";

const ComboList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: ComboListUrlQueryParams = asSortParams(
    qs,
    ComboListUrlSortField
  );
  return <ComboListComponent params={params} />;
};
const ComboDetails: React.FC<RouteComponentProps<{ id: string }>> = ({
  location,
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: ComboUrlQueryParams = qs;
  return (
    <ComboDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};
const ComboCreate: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: ComboAddUrlQueryParams = qs;
  return <ComboCreateComponent params={params} />;
};
export const ComboSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.combo)} />
      <Switch>
        <Route exact path={comboListPath} component={ComboList} />
        <Route exact path={comboAddPath} component={ComboCreate} />
        <Route path={comboPath(":id")} component={ComboDetails} />
      </Switch>
    </>
  );
};
export default ComboSection;
